var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1379 6.85761C41.1379 3.07046 38.0679 0 34.2816 0C27.077 0 14.0609 0 6.85631 0C3.06992 0 0 3.07046 0 6.85761V34.2931C0 38.0802 3.06992 41.1507 6.85631 41.1507H34.2816C38.0679 41.1507 41.1379 38.0802 41.1379 34.2931V6.85761Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9991 10.2799C47.9991 6.4936 44.9289 3.42383 41.1422 3.42383C33.9369 3.42383 20.9196 3.42383 13.7144 3.42383C9.92763 3.42383 6.85742 6.4936 6.85742 10.2799V37.7092C6.85742 41.4955 9.92763 44.5652 13.7144 44.5652H41.1422C44.9289 44.5652 47.9991 41.4955 47.9991 37.7092V10.2799Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8584 23.9928V37.7063C6.8584 41.4929 9.9285 44.563 13.7151 44.563H41.1421H41.2312C44.9767 44.515 47.9988 41.4638 47.9988 37.7063V29.1354C47.9988 29.1354 43.9739 20.5645 34.2853 20.5645C29.2799 20.5645 27.2349 22.99 25.2327 25.4927C23.8065 27.2755 22.4232 29.1354 18.8577 29.1354C17.0955 29.1354 15.3453 28.3966 13.866 27.5515C11.4867 26.1921 9.78451 24.4951 9.78451 24.4951C9.11598 23.8265 7.52693 23.3243 6.8584 23.9928Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0009 15.4238C24.0009 16.7877 23.4591 18.0957 22.4947 19.0601C21.5303 20.0245 20.2223 20.5664 18.8584 20.5664C17.4945 20.5664 16.1865 20.0245 15.222 19.0601C14.2576 18.0957 13.7158 16.7877 13.7158 15.4238C13.7158 14.0599 14.2576 12.7519 15.222 11.7875C16.1865 10.8231 17.4945 10.2813 18.8584 10.2812C20.2223 10.2812 21.5303 10.8231 22.4947 11.7875C23.4591 12.7519 24.0009 14.0599 24.0009 15.4238Z",
    fill: "url(#paint3_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 3.42926,
    y1: 39.4356,
    x2: 29.1507,
    y2: 0.00703732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 15.4289,
    y1: 30.8512,
    x2: 41.1417,
    y2: 6.8526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACD6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4D2F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 15.4293,
    y1: 44.563,
    x2: 34.2853,
    y2: 22.2786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 17.1442,
    y1: 18.8522,
    x2: 22.2867,
    y2: 11.9954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLogo);
export default __webpack_public_path__ + "static/media/uploadLogo.02e2c719c02837a6cdf02bdd9cdba92f.svg";
export { ForwardRef as ReactComponent };